import { getActionableWaypoint } from '@bringg-frontend/global-stores';
import { Task, TaskStatus } from '@bringg/types';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { getRoot } from 'mobx-easy';

import RootStore from 'bringg-web/stores/root-store';

export const isRouteInvalid = (routeId: number): boolean =>
	getRouteTasks(routeId).some(task => {
		const waypoint = getActionableWaypoint(task);
		return !waypoint.eta;
	});

export const getRouteTasks = (routeId: number): Task[] => {
	const route = getRoot<RootStore>().data.runStore.get(routeId);

	if (!route || !route.task_ids.length) {
		return [];
	}

	return getRootEnv().dashboardSdk.sdk.v2.tasks.getMany(route.task_ids);
};

export const getFirstTask = (routeId: number): Task => {
	return getRouteTasks(routeId).find(task => task.status !== TaskStatus.Cancelled && task.status !== TaskStatus.Done);
};
